import { Alert, Skeleton } from "@gravity-ui/uikit";
import { CounterDto } from "definitions/counter-api";
import { DontHaveSubscribeBlock } from "src/widgets";
import { LimiterCard } from "src/widgets/LimiterCard";

export interface LimitCardsListProps {
  limiters: CounterDto[] | null;
  isLoading?: boolean;
}

export const LimitCardsList = ({
  limiters,
  isLoading,
}: LimitCardsListProps) => {
  if (isLoading) return <Skeleton style={{ height: 120 }} />;

  if (!limiters)
    return <Alert theme="danger" title="Ошибка получения данных" />;

  if (limiters?.length <= 0) return <DontHaveSubscribeBlock />;

  return (
    <>
      {limiters.map((limiter) => {
        return (
          <LimiterCard
            key={`limiter_${limiter.id}`}
            rateLimits={limiter.rateLimits}
            countCompletedRequest={limiter.spent ?? null}
            maxCompleteRequest={limiter.total ?? null}
            limitEndTime={limiter.expireAt}
            type={limiter.type}
          />
        );
      })}
    </>
  );
};
